import { SpinnerCircleProps } from './Circle';
import { SpinnerPulseProps } from './Pulse';
import Spinner from './Spinner';
import { SpinnerProps } from './types';

export type { SpinnerProps, SpinnerCircleProps, SpinnerPulseProps };
export default Spinner;
